var _title, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconThreeDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {},
    xmlSpace: "preserve",
    width: 32,
    height: 8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none",
    className: "",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg_1",
    className: "selected",
    opacity: 1,
    fill: "#8b97c6",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.968,-7.105427357601002e-15 C1.775,-7.105427357601002e-15 0,1.7739999999999938 0,3.965999999999994 c0,2.192 1.7730000000000001,3.967 3.968,3.967 c2.189,0 3.966,-1.772 3.966,-3.967 C7.934,1.7739999999999938 6.157,-7.105427357601002e-15 3.968,-7.105427357601002e-15 zM16.233,-7.105427357601002e-15 c-2.188,0 -3.968,1.7730000000000001 -3.968,3.965 c0,2.192 1.778,3.967 3.968,3.967 s3.9699999999999998,-1.772 3.9699999999999998,-3.967 C20.201,1.7739999999999938 18.423000000000002,-7.105427357601002e-15 16.233,-7.105427357601002e-15 zM28.09,-7.105427357601002e-15 c-2.192,0 -3.9690000000000003,1.774 -3.9690000000000003,3.967 c0,2.19 1.774,3.965 3.9690000000000003,3.965 c2.188,0 3.965,-1.772 3.965,-3.965 S30.278,-7.105427357601002e-15 28.09,-7.105427357601002e-15 z",
    id: "svg_2",
    opacity: 1,
    fill: "#8b97c6",
    fillOpacity: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThreeDots);
export default __webpack_public_path__ + "static/media/icon-three-dots.bdd248d64ef685ce0b44f960bb6801fe.svg";
export { ForwardRef as ReactComponent };